/* 


@PRAKT


   _____________________________________________________________

   |
   | EMBEDED
   |
   _____________________________________________________________
*/

import gsap from 'gsap';

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class Embeded {
    constructor() {
        this.init();
        
    }

    init() {
        this.emb_list = document.querySelectorAll( '.block__content.block_emb' );
        if( this.emb_list.length > 0 ) this.coverAction();
    }

    coverAction() {
        this.emb_list.forEach( e => {
            const cover = e.querySelector( 'p' );
            const iframe = e.querySelector( 'iframe' );
            if( !cover ) return;
            cover.addEventListener( 'click', () => {
                setTimeout( () => { iframe.src += "&autoplay=1"; }, 200 );
                this.hideCover( cover );
            } );
        } );
    }

    hideCover( cover_ ) {
        const cover = cover_;
        gsap.to( cover, {
            duration: 0.5,
            ease: 'power2.inOut',
            opacity: 0,
            onComplete: () => {
                cover.remove();
            }
        } );
    }
}